import React from "react";
import { useMobileDetection } from "./hooks/useMobileDetection";

type GradientButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string;
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  style?: React.CSSProperties;
};

export const GradientButton = ({
  children,
  onClick,
  disabled,
  style,
  className = "",
  ...props
}: GradientButtonProps) => {
  const { isMobile } = useMobileDetection();

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`text-white! no-underline! flex items-center justify-center gap-2 rounded-sm bg-gradient-to-br from-[#AD46FF] to-[#0659D9] text-xs transition-shadow duration-300 hover:shadow-lg disabled:opacity-50 ${isMobile ? "px-3 py-2" : "px-12 py-2 font-medium"} ${className}`}
      style={style}
      {...props}
    >
      {children}
    </button>
  );
};
